import { useContext } from "react";
import { MlVectorTileLayer } from "@mapcomponents/react-maplibre";
import config from "../config";
import { DataContext } from "../context/DataContext";
import { useTheme } from "@mui/material/styles";
import { defaultTheme } from "../index";

export default function GLöZ2Areas() {
    const dataContext = useContext(DataContext);
    const theme = useTheme(defaultTheme);
    const layerConfigs = () => {
        return [
            {
                id: "GLöZ2_areas_fill",
                type: "fill",
                "source-layer": "kulisse",
                paint: {
                    "fill-color": theme.palette.layers?.GLöZ2Areas,
                    "fill-opacity": dataContext.GLöZ2AreasHidden
                        ? 0
                        : dataContext.GLöZ2AreasOpacity,
                },
                maxzoom: 22,
                minzoom: 8,
            },
            {
                id: "GLöZ2_areas_line",
                type: "line",
                "source-layer": "kulisse",
                paint: {
                    "line-color": theme.palette.layers?.GLöZ2Line,
                    "line-opacity": dataContext.GLöZ2AreasHidden ? 0 : 1,
                },
                layout: { visibility: "none" },
                maxzoom: 22,
                minzoom: 8,
            },
            {
                id: "GLöZ2_areas_text",
                type: "symbol",
                "source-layer": "kulisse",
                paint: {
                    "text-opacity": dataContext.GLöZ2AreasHidden
                        ? 0
                        : dataContext.GLöZ2AreasOpacity,
                },
                layout: {
                    "text-field": ["get", "kat_lang"],
                    "text-font": ["Klokantech Noto Sans Regular"],
                    visibility: "none",
                },
                maxzoom: 22,
                minzoom: 11,
            },
        ];
    };

    return (
        <>
            <MlVectorTileLayer
                mapId="map_1"
                layerId="Moor_flaeche"
                url={
                    config.tileServerHost +
                    "tileservergl/data/moor_flaeche/{z}/{x}/{y}.pbf?"
                }
                insertBeforeLayer="flik-data_sachs"
                sourceOptions={{
                    attribution:
                        "Kulisse org. Böde: CC BY 4.0 - Arbeitsgruppe Moorforschung Institut für Agrarklimaschutz",
                    maxzoom: 16,
                    minzoom: 8,
                }}
                layers={layerConfigs()}
            />
          
        </>
    );
}
